import PosthogService from '~/services/posthog/PosthogService';

export function fireMenuBarProfessionalHubClicked(): void {
  PosthogService.getInstance().track('dental_portal:menu_bar:professional_hub_clicked');
}
